import { toast } from "react-toastify";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

export const IS_LIVE = true

export const imgBaseURL = () => {
  // Original production/dev remote URLs (kept commented for easy revert)
   return IS_LIVE ? "https://bluebridgecorporation.com/" : "https://humanoid.itworkshop.in/";

  // In development (IS_LIVE=false) point to local backend static/public folder
  //return IS_LIVE ? "https://bluebridgecorporation.com/" : "http://127.0.0.1:5005/";
};
export const apiBaseURL = () => {
  // Original production/dev remote API (kept commented for easy revert)
   return IS_LIVE ? "https://bluebridgecorporation.com/api" : "https://humanoid.itworkshop.in/api/";

  // In development (IS_LIVE=false) use local backend API
  //return IS_LIVE ? "https://bluebridgecorporation.com/api" : "http://127.0.0.1:5005/api/";
};

export const apiVersion = () => {
  return "/v1/";
};

export const getRootURL = (role) => {
  return "admin"
}

export const getUserRootURL = (role) => {
  return "/"
}

export const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000
// export const TWENTY_FOUR_HOURS = 10 * 60 * 1000

export const PLAN_LIMITS = {
  Basic: { maxImages: 1, maxVideos: 0, maxVidSec: 0 },
  Silver: { maxImages: 3, maxVideos: 0, maxVidSec: 0 },
  Gold: { maxImages: Infinity, maxVideos: Infinity, maxVidSec: 30 },
  Premium: { maxImages: Infinity, maxVideos: Infinity, maxVidSec: Infinity }
};

export const countMedia = filesArr => {
  let img = 0, vid = 0;
  filesArr.forEach(f => {
    const isImg = f.type ? f.type.startsWith('image/') : /\.(jpe?g|png|gif|webp)$/i.test(f);
    const isVid = f.type ? f.type.startsWith('video/') : /\.(mp4|webm|ogg)$/i.test(f);
    if (isImg) img += 1;
    if (isVid) vid += 1;
  });
  return { img, vid };
};

export const getVideoDuration = file =>
  new Promise(res => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      res(video.duration);      // seconds
    };
    video.src = url;
  });

export const filterByKey = (key, obj) => {
  if (auth("admin")?.user_role === "admin") {
    const data = { edit: true, read: true, delete: true, create: true };
    return data;
  } else {
    if (!obj || typeof obj !== "object") {
      return null;
    }
    return obj.hasOwnProperty(key) ? obj[key] : null;
  }
};

export const formatdedDate = (date) => {
  if (!(date instanceof Date)) {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) {
      return "";
    }
    date = parsedDate;
  }

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const formattedDateTime = `${formattedDate} ${formattedTime}`;
  return formattedDateTime;
};

export function getTimeOnly(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleTimeString('en-US', {
    // timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export const getDayName = (dateStr) => {
  const [day, month, year] = dateStr.split("-");
  const isoDateStr = `${year}-${month}-${day}`;
  const date = new Date(isoDateStr);
  return date.toLocaleDateString("en-US", { weekday: "short" });
};

// 1. encryptSessionStorageData
export const encryptSessionStorageData = (name, data, key) => {
  var encryptData = AES.encrypt(JSON.stringify(data), key).toString();
  sessionStorage.setItem(name, encryptData);
};

// 2. dycryptSessionStorageData
export const dycryptSessionStorageData = (encryptData, key) => {
  var bytes = AES.decrypt(encryptData, key);
  var decryptedData = JSON.parse(bytes.toString(Utf8));
  return decryptedData;
};

export const authUser = () => {
  if (sessionStorage.getItem("admin-secret")) {
    return dycryptSessionStorageData(
      sessionStorage.getItem("admin-secret"),
      "DoNotTryToAccess"
    );
  } else {
    return null;
  }
};

// 3. encryptLocalStorageData
export const encryptLocalStorageData = (name, data, key) => {
  var encryptData = AES.encrypt(JSON.stringify(data), key).toString();
  localStorage.setItem(name, encryptData);
};

// 4. dycryptLocalStorageData
export const dycryptLocalStorageData = (encryptData, key) => {
  var bytes = AES.decrypt(encryptData, key);
  var decryptedData = JSON.parse(bytes.toString(Utf8));
  return decryptedData;
};

export const getTokenType = (type) => {
  if (type === "user") {
    return "user-secret";
  } else if (type === "admin") {
    return "admin-secret";
  }
};

export const auth = (type) => {
  if (localStorage.getItem(getTokenType(type))) {
    return dycryptSessionStorageData(
      localStorage.getItem(getTokenType(type)),
      "DoNotTryToAccess"
    );
  } else {
    return null;
  }
};

export const formatTo12Hour = (time24) => {
  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${ampm}`;
}

export const convertTo24Hour = (time12h) => {
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");

  if (modifier === "PM" && hours !== "12") {
    hours = String(parseInt(hours, 10) + 12);
  } else if (modifier === "AM" && hours === "12") {
    hours = "00";
  }

  return `${hours.padStart(2, "0")}:${minutes}`;
};

export const generateSlug = (str) => {
  return str
    .toLowerCase()
    .replace(/[\s_]/g, "-")
    .replace(/[^\w-]+/g, "");
};

export const toastifySuccess = (message) => {
  toast.success(`${message}`, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
};

export const toastifyError = (message) => {
  toast.error(`${message}`, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
};

export function filterListByValue(list, searchValues, exactMatchKeys = []) {
  if (!Object.values(searchValues).some((values) => values.length > 0)) {
    return list;
  }
  return list.filter((item) => {
    return Object.entries(searchValues).every(([key, values]) => {
      if (values.length === 0) {
        return true;
      }
      if (exactMatchKeys.includes(key)) {
        return values.some((searchValue) => {
          return item[key] == searchValue;
        });
      }
      return values.some((searchValue) => {
        return item[key].toLowerCase().includes(searchValue.toLowerCase());
      });
    });
  });
}

export const textSlice = (text, char) => {
  if (text?.length > char) {
    return text.slice(0, char) + "...";
  } else {
    return text;
  }
};

export const textFormated = (text) => {
  const words = text?.replace(/[_-]/g, " ").split(" ");
  const formattedText = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return formattedText;
};

export const stringToArray = (str) => {
  if (!str) return [];
  const stringArray = str.split(",");
  const numberArray = stringArray.map((item) => {
    const parsed = parseInt(item.trim(), 10);
    return isNaN(parsed) ? null : parsed;
  });
  return numberArray.filter((item) => item !== null);
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
  const day = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  let minutes = date.getMinutes();

  if (minutes < 10) {
    // Adding leading zero to minutes
    minutes = `0${minutes}`;
  }
  if (prefomattedDate) {
    // Today at 10:20
    // Yesterday at 10:20
    return `${prefomattedDate} at ${hours}:${minutes}`;
  }
  if (hideYear) {
    // 10. January at 10:20
    return `${day} ${month} at ${hours}:${minutes}`;
  }
  // 10. January 2017. at 10:20
  return `${day} ${month} ${year} at ${hours}:${minutes}`;
}

// --- Main function
export function timeAgo(dateParam) {
  if (!dateParam) {
    return null;
  }
  const date = typeof dateParam === "object" ? dateParam : new Date(dateParam);
  const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
  const today = new Date();
  const yesterday = new Date(today - DAY_IN_MS);
  const seconds = Math.round((today - date) / 1000);
  const minutes = Math.round(seconds / 60);
  const isToday = today.toDateString() === date.toDateString();
  const isYesterday = yesterday.toDateString() === date.toDateString();
  const isThisYear = today.getFullYear() === date.getFullYear();

  if (seconds < 5) {
    return "just now";
  } else if (seconds < 60) {
    return `${seconds} seconds ago`;
  } else if (seconds < 90) {
    return "about a minute ago";
  } else if (minutes < 60) {
    return `${minutes} minutes ago`;
  } else if (isToday) {
    return getFormattedDate(date, "Today"); // Today at 10:20
  } else if (isYesterday) {
    return getFormattedDate(date, "Yesterday"); // Yesterday at 10:20
  } else if (isThisYear) {
    return getFormattedDate(date, false, false); // 10. January at 10:20
  }

  return getFormattedDate(date); // 10. January 2017. at 10:20
}

export const allDays = [
  { key: "Sun", label: "Sunday" },
  { key: "Mon", label: "Monday" },
  { key: "Tue", label: "Tuesday" },
  { key: "Wed", label: "Wednesday" },
  { key: "Thu", label: "Thursday" },
  { key: "Fri", label: "Friday" },
  { key: "Sat", label: "Saturday" },
];

const isVideo = (fileName) => {
  const videoExtensions = ['.mp4', '.mov', '.avi', '.webm'];
  return videoExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
};

export const renderMedia = (mediaUrl, height = 50, width = 50) => {
  const url = imgBaseURL() + mediaUrl;

  if (isVideo(mediaUrl)) {
    return (
      <video
        className="mx-1"
        style={{ height: `${height}px`, width: `${width}px`, objectFit: 'cover' }}
        src={url}
        controls
        muted
      />
    );
  } else {
    return (
      <img
        className="mx-1"
        style={{ height: `${height}px`, width: `${width}px`, objectFit: 'cover' }}
        src={url}
        alt="media"
      />
    );
  }
};

export const getMediaType = (mediaUrl) => {
  if (!mediaUrl) return null;
  return isVideo(mediaUrl) ? 'video' : 'image';
};

export const notificationRedirect = (navigate, row) => {
  const authUser = auth('user')
  const baseURL = authUser ? "" : `/${getRootURL()}`;
  if (!row?.type) return;
  switch (row.type) {
    case 'job':
      navigate(`${baseURL}/dashboard`);
      break;
    case 'signup':
      navigate(`${baseURL}/user/employee`);
      break;
    case 'job-hired':
      navigate(`${baseURL}/employerAllJob`);
      break;
    case 'account-status':
      navigate(`${baseURL}/profile`);
      break;
    case 'admin-redeem-request':
      navigate(`${baseURL}/campaign`);
      break;
    default:
      navigate(`${baseURL}/${row.type}`);
  }
};


// --- Lazy-load Google Identity Services script (only when needed) ---
let googleScriptPromise = null;

const loadGoogleScript = () => {
  // Already loaded
  if (window.google?.accounts?.oauth2) {
    return Promise.resolve();
  }
  // Already loading — reuse the same promise so parallel clicks don't inject twice
  if (googleScriptPromise) {
    return googleScriptPromise;
  }

  googleScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
    if (existing) {
      existing.addEventListener("load", resolve);
      existing.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => {
      googleScriptPromise = null; // allow retry on next click
      reject(new Error("Failed to load Google SDK"));
    };
    document.body.appendChild(script);
  });

  return googleScriptPromise;
};

export const googleSignIn = (clientId) => {
  return new Promise((resolve, reject) => {
    if (!window.google) {
      reject("Google SDK not loaded");
      return;
    }

    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: "email profile",
      callback: (response) => {
        if (response.error) reject(response.error);
        else resolve(response.access_token);
      },
    });

    client.requestAccessToken();
  });
};

export const getGoogleUser = (clientId) => {
  return new Promise(async (resolve, reject) => {
    try {
      await loadGoogleScript();
    } catch (err) {
      reject("Google SDK failed to load");
      return;
    }

    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: "email profile openid",
      callback: async (tokenResponse) => {
        if (tokenResponse.error) {
          reject(tokenResponse.error);
          return;
        }
        try {
          const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          });
          const userInfo = await res.json();
          resolve(userInfo);
        } catch (err) {
          reject(err);
        }
      },
    });

    client.requestAccessToken();
  });
};

export const getGuestId = () => {
  let guestId = localStorage.getItem("bb_guest_id");
  if (!guestId) {
    guestId = "guest_" + crypto.randomUUID();
    localStorage.setItem("bb_guest_id", guestId);
  }
  return guestId;
};
